import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import CardNetworks from '../../_common/cardNetworks.mdx';
import PossibleTypes from './onCardMetadataChangePossibleTypes.mdx';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Group = makeShortcode("Group");
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`Called when the card metadata changes. Takes a `}<inlineCode parentName="p">{`CardMetadata`}</inlineCode>{` object as its argument.`}</p>
    <Group summary='CardMetadata' mdxType="Group">
      <Item title='type' subtitle='CardNetwork | null' label='Deprecated' mdxType="Item">
        <p><em parentName="p">{`Deprecated: Use `}<a parentName="em" {...{
              "href": "#card.parameters.options-properties.onCardNetworksChange"
            }}>{`onCardNetworksChange`}</a>{` instead`}</em></p>
        <CardNetworks mdxType="CardNetworks" />
      </Item>
      <Item title='possibleTypes' subtitle='CardNetwork[]' label='Deprecated' mdxType="Item">
        <p><em parentName="p">{`Deprecated: Use `}<a parentName="em" {...{
              "href": "#card.parameters.options-properties.onCardNetworksChange"
            }}>{`onCardNetworksChange`}</a>{` instead`}</em></p>
        <PossibleTypes mdxType="PossibleTypes" />
      </Item>
	<Item title='cvvLength' subtitle='number' mdxType="Item">
		Usually 3 digits, but can sometimes be 4.
	</Item>
	<Item title='cardNumberLength' subtitle='number' mdxType="Item">
		Represents the length of the card number for the given card type.
	</Item>
    </Group>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      